// ecosystem-hub-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Não foi possível carregar o Ecosystem Hub. Tente recarregar.": "No fue posible cargar el Ecosystem Hub. Intente recargar.",
    "O Ecosystem Hub ainda não foi publicado neste ambiente.": "El Ecosystem Hub aún no fue publicado en este entorno.",
    "Você não tem permissão para ver o Ecosystem Hub.": "Usted no tiene permiso para ver el Ecosystem Hub.",
    "documentação interna · admin only · carregado com login via API": "documentación interna · solo admin · cargada con inicio de sesión vía API",
};

export default catalogo;
